import { render, staticRenderFns } from "./s04-documentation.vue?vue&type=template&id=41e55e43&scoped=true"
import script from "./s04-documentation.vue?vue&type=script&lang=js"
export * from "./s04-documentation.vue?vue&type=script&lang=js"
import style0 from "./s04-documentation.vue?vue&type=style&index=0&id=41e55e43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e55e43",
  null
  
)

export default component.exports